/** @jsx jsx */
import { jsx } from "theme-ui"
import { Component } from "react"
import { InstantSearch } from "react-instantsearch-dom"
import { navigate as reachNavigate } from "@gatsbyjs/reach-router"
import { debounce } from "lodash-es"
import { Search } from "./Search"

// This is for the urlSync
const updateAfter = 700

// the search bar holds the Search component in the InstantSearch widget
class PluginSearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = { searchState: { query: this.urlToSearch(), page: 1 } }
    this.updateHistory = debounce(this.updateHistory, updateAfter)
  }

  urlToSearch = () => {
    if (this.props.location.search) {
      const match = /(\?|&)=([^&]+)/.exec(this.props.location.search)
      if (match) return decodeURIComponent(match[2])
      return ``
    }
    return ``
  }

  updateHistory(value) {
    if (value?.query) {
      reachNavigate(
        `${this.props.location.pathname}?=${encodeURIComponent(value.query)}`,
        {
          replace: true,
        }
      )
    } else {
      reachNavigate(this.props.location.pathname, {
        replace: true,
      })
    }
  }

  onSearchStateChange = searchState => {
    this.updateHistory(searchState)
    this.setState({ searchState })
  }

  render() {
    return (
      <InstantSearch
        apiKey="ae43b69014c017e05950a1cd4273f404"
        appId="OFCNCOG2CU"
        indexName="npm-search"
        searchState={this.state.searchState}
        onSearchStateChange={this.onSearchStateChange}
      >
        <Search
          pathname={this.props.location.pathname}
          query={this.state.searchState.query}
        />
      </InstantSearch>
    )
  }
}

export default PluginSearchBar
